import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { usePlansDataStore } from '@store/plansStore';
import { numberWithCommas } from '@utils/comparationUtils';

import abaSegurosLogo from '@assets/images/aba.png';
import Vector from '@assets/images/priceAsset.svg';
import {
  useQuoteStore,
  useSelectedQuoteStore,
} from '../../../store/QuoteStore';

export const PriceDesktop = () => {
  const { selectedPlan, paymentMode } = usePlansDataStore();
  const { selectedQuote } = useSelectedQuoteStore();
  const [totalPayment, setTotalPayment] = useState<string>('');
  useEffect(() => {
    let totalNumber = 0;
    selectedQuote.receipts.map((item: any) => {
      const number = Number(item?.total_premium);
      totalNumber += number;
    });
    setTotalPayment(totalNumber.toString());
  }, []);
  return (
    <Box
      display={'flex'}
      flexDirection={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
      borderRadius={2}
      marginTop="19px"
      paddingLeft="50px"
      paddingRight="50px"
    >
      <Box
        width={278}
        height={100}
        borderRadius={'10px 0 0 10px '}
        style={{ backgroundColor: '#F8F8F8' }}
      >
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          justifyContent={'center'}
          height={100}
        >
          <Box
            component={'img'}
            src={selectedQuote.company_logo}
            alt={selectedQuote.company_name}
            sx={{
              width: '78%',
              height: '100%',
            }}
            style={{ objectFit: 'contain' }}
          />
        </Box>
      </Box>
      <Box
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        width={279}
        height={100}
        borderRadius={'0 10px 10px 0'}
        style={{
          backgroundColor: '#F0F0F0',
          position: 'relative',
        }}
      >
        <Box
          component={'img'}
          src={Vector}
          style={{
            position: 'absolute',
            top: 'calc(50% - 15.85px)',
            left: '0px',
          }}
        />
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'start'}
          padding={1}
        >
          <Typography variant="subtitle2" color="#8F8F8F" fontSize={16}>
            Costo anual
          </Typography>
          <Typography
            variant="subtitle2"
            style={{ fontWeight: 'bold' }}
            fontSize={28}
          >
            $
            {parseFloat(parseFloat(totalPayment).toFixed(2)).toLocaleString(
              'es-MX',
              { minimumFractionDigits: 2 }
            )}
          </Typography>
          <Typography fontSize={12} style={{ color: '#8F8F8F' }}></Typography>
        </Box>
      </Box>
    </Box>
  );
};
